import {lighten, makeStyles} from "@material-ui/core/styles";
import FuseAnimate from "../fuse-animate/fuse-animate";
import {Card} from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import React from "react";
import ausPhone from "../../utils/aus-phone";
import format from '../../utils/format';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    accordionSummary: {
        '&:hover, &:focus, &:active': {
          // backgroundColor:  grey[200],
            backgroundColor: lighten(theme.palette.primary.light, 0.85)
        },
    },
    expanded: {
        // backgroundColor: grey[200],
        backgroundColor: lighten(theme.palette.primary.light, 0.85)
    },
    accordionDetails: {
        // backgroundColor: grey[50],
        backgroundColor: lighten(theme.palette.primary.light, 0.95)
    },
    linkButton: {
        marginTop: 24,
    },
    dataLabel: {
        minWidth: 75,
        fontWeight: 500,
    },
    headerRow: {
        display: 'flex',
        flexGrow: 1,
        textTransform: 'uppercase',
        paddingBottom: '0.5rem',
        marginLeft: 16,
        marginRight: 48,
    },
}));


const RecentCalls = ({ calls, animation, delay }) => {
    const classes = useStyles();

    //console.log('RecentCalls: calls =', calls);

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="calls-card" className={classes.root}>
                <Typography variant="h6" color="secondary">Recent Calls</Typography>

                <div className="mt-4">

                    {/* Column Headers */}
                    <div className="flex flex-grow border-b-2">
                        <div className={classes.headerRow}>
                            <div className="w-7/12 md:w-1/4">From</div>
                            <div className="hidden md:flex md:w-1/4">To</div>
                            <div className="w-5/12 md:w-1/4">When</div>
                            <div className="hidden md:flex md:w-1/4">Duration</div>
                        </div>
                    </div>

                    { calls.length === 0 ? <div className="p-4">No recent calls.</div> : null }

                    {/* Table Row */}
                    { calls.map((call) => (
                        <Accordion key={call.sid}>
                            <AccordionSummary
                                classes={{root: classes.accordionSummary, expanded: classes.expanded}}
                                expandIcon={<ExpandMoreIcon/>}
                            >
                                <div className="flex flex-row flex-grow font-light">
                                    <div className="w-7/12 md:w-1/4 font-bold">{ausPhone(call.from)}</div>
                                    <div className="hidden md:flex md:w-1/4">{ausPhone(call.to)}</div>
                                    <div className="w-5/12 md:w-1/4">{format('ago',call.startTime)}</div>
                                    <div className="hidden md:flex md:w-1/4">{format('duration', call.duration)}</div>
                                </div>
                            </AccordionSummary>

                            <AccordionDetails
                                className={classes.accordionDetails}
                            >
                                <div className="flex flex-col flex-grow font-light">

                                    <div className="flex flex-col md:flex-row">
                                        <div className="flex flex-row p-1 md:w-1/2">
                                            <div className={classes.dataLabel}>Time</div>
                                            <div className="">
                                                <span className="pr-1">{format('date-long', call.startTime)}</span>
                                                <span className="" dangerouslySetInnerHTML={{__html: format('time-12h', call.startTime)}}/>
                                            </div>
                                        </div>
                                        <div className="flex flex-row p-1 md:w-1/2">
                                            <div className={classes.dataLabel}>Direction</div>
                                            <div className="capitalize">{format('direction', call.direction)}</div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col md:flex-row">
                                        <div className="flex flex-row p-1 md:w-1/2">
                                            <div className={classes.dataLabel}>From</div>
                                            <div className="">{ausPhone(call.from)}</div>
                                        </div>
                                        <div className="flex flex-row p-1 md:w-1/2">
                                            <div className={classes.dataLabel}>To</div>
                                            <div className="">{ausPhone(call.to)}</div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col md:flex-row">
                                        <div className="flex flex-row p-1 md:w-1/2">
                                            <div className={classes.dataLabel}>Duration</div>
                                            <div className="">{format('duration', call.duration)}</div>
                                        </div>
                                        <div className="flex flex-row p-1 md:w-1/2">
                                            <div className={classes.dataLabel}>Status</div>
                                            <div className="capitalize">{call.status}</div>
                                        </div>
                                    </div>

                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))}

                </div>


                <Button variant="outlined"
                        color="primary"
                        size="large"
                        component={Link}
                        to="/calls"
                        className={classes.linkButton}
                >View All Calls</Button>

            </Card>
        </FuseAnimate>
    )
}



export default RecentCalls;